module.exports = __webpack_public_path__ + "static/image/jinggongwang.png?1b5f50da64493561ef24652c852697a2";